import { KText } from '@/ui-library/components/text';
import { Box, Flex } from '@chakra-ui/react';
import { KTag } from 'ui-library/components';

const Badge = ({ children }) => {
  return (
    <Box mr="8px" p="2px 6px" borderRadius="5px">
      {children}
    </Box>
  );
};

const BluePrint = ({ selected = {}, blueprint = {}, onClick = () => {} }) => {
  return (
    <Box
      p="12px 22px"
      borderBottom="1px solid"
      borderColor="border-color"
      bg={selected?.id === blueprint?.id ? 'secondary-25' : '#FFF'}
      _hover={{ bg: 'secondary-25' }}
      cursor="pointer"
      onClick={() => {
        onClick(blueprint);
      }}
      className="group"
    >
      <Flex>
        <Box flex={1}>
          <KText size="md-semi-bold" color="secondary-900">
            {blueprint?.name}
          </KText>
          <KText color="secondary-700">{blueprint?.description}</KText>
        </Box>
        <Box>
          <KTag
            borderRadius="6px"
            bg={selected?.id === blueprint?.id ? '#FFF' : ''}
            _groupHover={{ bg: '#FFF' }}
            value={`${blueprint?.steps} steps`}
            className="group-hover:bg-white"
          ></KTag>
        </Box>
      </Flex>
      <Flex mt="12px">
        {blueprint?.stats?.open_rate > 0 && (
          <Badge>
            <KTag
              _groupHover={{ bg: '#FFF' }}
              bg={selected?.id === blueprint?.id ? '#FFF' : ''}
              value={`${blueprint?.stats?.open_rate}% Open Rate`}
              className="group-hover:bg-white"
            ></KTag>
          </Badge>
        )}
        {blueprint?.stats?.reply_rate > 0 && (
          <Badge>
            <KTag
              _groupHover={{ bg: '#FFF' }}
              bg={selected?.id === blueprint?.id ? '#FFF' : ''}
              value={`${blueprint?.stats?.reply_rate}% Reply Rate`}
              className="group-hover:bg-white"
            ></KTag>
          </Badge>
        )}
      </Flex>
    </Box>
  );
};

export const BlueprintList = ({
  selected = {},
  blueprints = [],
  onSelect = () => {},
}) => {
  return (
    <Box h="calc(100% - 65px)" overflow="auto" borderRadius="0 0 0 25px">
      {blueprints?.map((blueprint) => (
        <BluePrint
          key={blueprint?.id}
          blueprint={blueprint}
          selected={selected}
          onClick={onSelect}
        />
      ))}
    </Box>
  );
};
